import { apiSlice } from './apiSlice';

export const excelUploadApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadExcelFile: builder.mutation({
      query: ({ importEntityType, excelFile }) => ({
        url: `/excel-imports/${importEntityType}`,
        method: 'POST',
        body: excelFile,
      }),
    }),
    saveExcelCustomMapping: builder.mutation({
      query: ({ importEntityType, excelCustomMapping }) => ({
        url: `/excel-imports/save/${importEntityType}`,
        method: 'POST',
        body: excelCustomMapping,
      }),
      invalidatesTags: ['Vehicle', 'Student', 'Employee'],
    }),
  }),
});

export const { useUploadExcelFileMutation, useSaveExcelCustomMappingMutation } =
  excelUploadApiSlice;
